<template>
  <div class="agenda-day">
    <hr class="hr-aqua" />
    <v-row no-gutters class="agenda-day__day">
      <v-col sm="12" md="3" class="agenda-day__day-label">
        <div class="day-of-week">
          {{ day }}
        </div>
        <div class="date">
          {{ date }}
        </div>
      </v-col>
      <v-col sm="12" md="9" class="agenda-day__times">
        <v-row
          no-gutters
          v-for="item in items"
          :key="item.time"
          class="agenda-day__time-group"
        >
          <v-col sm="3" class="agenda-day__time">
            <div class="time" v-html="item.time"></div>
          </v-col>
          <v-col sm="9">
            <div class="topic" v-html="item.topic" />
            <ul v-if="item.subTopics && item.subTopics.length > 0">
              <li v-for="(subTopic, index) in item.subTopics" :key="index">
                - {{ subTopic }}
              </li>
            </ul>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "AgendaDay",
  props: {
    day: String,
    date: String,
    items: Array
  }
};
</script>

<style lang="scss">
@media screen and (min-width: 960px) {
  .time-wrap {
    white-space: nowrap;
  }
}
</style>

<style scoped lang="scss">
@import "@/styles/variables.scss";

.agenda-day {
  padding-bottom: 10px;
  hr {
    margin: 0 0 17px;
  }

  .day-of-week {
    font-weight: 800;
    font-size: 24px;
    line-height: 30px;
    color: white;
    margin-bottom: 3px;
  }
  .date {
    font-weight: 800;
    font-size: 18px;
    line-height: 24px;
    color: $stjude-aqua;
  }

  &__time-group {
    padding-bottom: 24px;
  }
  .time,
  .topic {
    font-size: 18px;
    line-height: 24px;
    color: white;
  }
  &__time {
    font-weight: 800;
  }

  ul {
    list-style: none;
  }
  li {
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: white;
  }
}

@media screen and (max-width: 960px) {
  .agenda-day {
    &__day {
      flex-direction: column;
      &-label {
        margin-bottom: 50px;
      }
    }
    &__time {
      max-width: 84px;
      padding-right: 1em;
    }
  }
}
</style>
